export default __webpack_public_path__ + "static/media/caugiay.3e14269e.png";